/* __next_internal_client_entry_do_not_use__ TopBadges auto */ import { jsx as _jsx } from "react/jsx-runtime";
import { useGetProductTileClickImpressions } from "@faire/retailer-visitor-shared/features/MarketplaceItems/ComposableProductTile/__internal__/__internal__/productTileActions/useGetProductTileClickImpressions";
import { TopBadges as TopBadgesInternal } from "@faire/retailer-visitor-shared/features/MarketplaceItems/TopBadges";
import React from "react";
export var TopBadges = function(param) {
    var _param_data = param.data, showEventBadge = _param_data.showEventBadge, topBadge = _param_data.topBadge, hideBadge = _param_data.hideBadge, productToken = _param_data.productToken, badgeList = _param_data.badgeList;
    var recordProductBadgeViewEvent = useGetProductTileClickImpressions({
        token: productToken,
        badgeList: badgeList
    }).recordProductBadgeViewEvent;
    if (hideBadge) {
        return null;
    }
    return /*#__PURE__*/ _jsx(TopBadgesInternal, {
        tileBadge: topBadge,
        showEventBadge: showEventBadge,
        onTopLeftBadgeVisible: recordProductBadgeViewEvent
    }, "top-badges");
};
